import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import { Stack, Container } from '@mui/material'
import useOffSetTop from '../../hooks/useOffSetTop'
import { HEADER } from '../../config-global'
import Header from './Header'
import { useDomainContext } from '../../contexts/DomainContext'

export default function CompactLayout() {

    const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP)

    const { sucursal } = useDomainContext()

    return (
        <>
            {!!sucursal?.sc_css && (
                <Helmet>
                    <link rel="stylesheet" type="text/css" href={`/css/${sucursal?.sc_css}`} />
                </Helmet>
            )}
            <Header isOffset={isOffset} />
            <Container id="app-container" component="main">
                <Stack
                    sx={{
                        py: 12,
                        m: 'auto',
                        maxWidth: 600,
                        minHeight: '100vh',
                        textAlign: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Outlet />
                </Stack>
            </Container>
        </>
    );
}
